module.exports = __webpack_public_path__ + "ecce855d1b3099e4b7d882b171ea472a.png";